<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="mgt-20px column is-10">
      <div class="card" id="caracteristiques">
        <header class="header-card">
          <p>
            {{ $t('dispositifPublicitaire.caracteristiques') }}
          </p>
        </header>
        <div class="card-content columns">
          <div class="column is-2">
            <ligne-commande-attachement
                class="mgh-20px"
                :id="face.produitId"
                :context="constantes.module"
                :libelleImage="$t('detailFace.title',
                                  { name: this.face.materiel.type.libelle })"
                :permissions="constantes.EMPLACEMENT.lecture"
                :resizeFile="false"
                :readOnly="true"
                :withToolTip="false">
            </ligne-commande-attachement>
          </div>
          <div class="column is-10 columns is-multiline">
            <div class="column is-3">
              <b-field :label="$t('detailFace.carrac.code')" custom-class="has-text-link">
                <p>{{ face.code }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('detailFace.carrac.commericalisable')"
                custom-class="has-text-link">
                <p>{{ loadFaceMotifNonCom(face.faceMotifNonComId) }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('detailFace.carrac.declarableMairie')"
                custom-class="has-text-link">
                <p>{{ face.declarableEnMairie ? $t('general.oui') : $t('general.non') }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailFace.carrac.proposableLc')" custom-class="has-text-link">
                <p>{{ face.proposableLc ? $t('general.oui') : $t('general.non') }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field
                :label="$t('detailFace.carrac.proposableReseau')"
                custom-class="has-text-link">
                <p>{{ face.proposableReseau ? $t('general.oui') : $t('general.non') }}</p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <montage-demontage-consultation :dispositif-publicitaire="face" id="montage">
      </montage-demontage-consultation>
      <div class="card mgt-30px">
        <header class="header-card">
          <p>
            {{ $t('detailFace.pj.title') }}
          </p>
        </header>
        <div class="card-content" id="pj">
          <app-pieces-jointes :checkPermissions=checkPermissions(constantes.EMPLACEMENT.maj)
                              class="mgt-20px"
                              readOnly
                              deletable
                              autoSave>
          </app-pieces-jointes>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user class="mgr-20px" :data="face">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>
import PiecesJointes from '@/components/general/piecesJointes';
import montageDemontageConsultation from '@/components/gabed/dispositif/c_montageDemontage';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import messageErreur from '@/services/general/messageErreur';
import ligneCommandeAttachement from '@/components/commande/logistique/ligneCommandeAttachement';
import { MODULE_DETAIL_FACE } from '@/configuration/general/pieceJointeConf';
import dotsMenu from '@/components/general/dotsMenu';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'infoGenerale',
  data() {
    return {
      steps: [
        {
          name: this.$i18n.t('detailFace.steps.caracteristiques'),
          ref: '#caracteristiques',
          active: true,
        },
        {
          name: this.$i18n.t('detailFace.steps.montage'),
          ref: '#montage',
          active: false,
        },
        {
          name: this.$i18n.t('detailFace.steps.pj'),
          ref: '#pj',
          active: false,
        },
      ],
      constantes: {
        EMPLACEMENT,
        module: MODULE_DETAIL_FACE,
      },
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    montageDemontageConsultation,
    ligneCommandeAttachement,
    dotsMenu,
    InformationCreateUpdateUser,
  },
  props: {
    face: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    loadFaceMotifNonCom(id) {
      if (!id) return '';
      const motif = this.parametre(
        typesParametres.PARAMETRES_KEYS.faceMotifNonCom,
      ).find((faceMotifNonCom) => { return faceMotifNonCom.id === id; });
      return motif ? motif.libelle : '';
    },
  },
  async mounted() {
    try {
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.faceMotifNonCom]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
